import { Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GetFranchPrices } from '../../actions/cities';
import LowSubscribeComponent from '../../components/DashBossView/LowSubscribeComponent';
import BlockDayComponent from './BlockDay';
import PaymentsMediaCard from './changeCityPrice';
import SummerIntencive from './changeLiPrice';
import CubePrice from './changeCubePrice';

const pricesItems = ['price_li_online', 'price_online', 'price_cube_online'];

const CityProperties = ({ recivedPrice, liPrice, cubePrice }) => {
    const { t } = useTranslation();
    const [prices, setPrices] = useState(null);
    const [loading, setLoading] = useState(false);
    const fetchData = async () => {
        setLoading(true);
        const avgPriceOnline = await GetFranchPrices({
            code: pricesItems[pricesItems.findIndex(el => el === 'price_online')],
        });

        const avgPriceLiOnline = await GetFranchPrices({
            code: pricesItems[pricesItems.findIndex(el => el === 'price_li_online')],
        });

        const avgPriceCubeOnline = await GetFranchPrices({
            code: pricesItems[pricesItems.findIndex(el => el === 'price_cube_online')],
        });

        if (!avgPriceOnline || !avgPriceLiOnline) return;

        setPrices({
            price_li_online: avgPriceLiOnline,
            price_online: avgPriceOnline,
            price_cube_online: avgPriceCubeOnline,
        });
        setLoading(false);
    };
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <Box>
            <Typography style={{ margin: '40px 0px 10px 0px' }} variant="subtitle2" component="p">
                *{t('payments.city_price_descr')}
            </Typography>
            <Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
                {pricesItems.map((code, index) => {
                    return (
                        <LowSubscribeComponent
                            key={index}
                            value={!loading && prices ? prices[code]?.payload[`avg_${code}`] : 0}
                            minValue={!loading && prices ? prices[code]?.payload[`min_${code}`] : 0}
                            isLoading={loading}
                            code={`avg_${code}`}
                            updatePrices={() => fetchData()}
                            titleSet={code === 'price_cube_online' ? t('finance.cubePriceSetOnline') : undefined}
                        />
                    );
                })}
                <PaymentsMediaCard recivedPrice={recivedPrice} />
                <SummerIntencive recivedPrice={liPrice} />
                <CubePrice recivedPrice={cubePrice} />
                <BlockDayComponent />
            </Box>
        </Box>
    );
};

export default CityProperties;
